// extracted by mini-css-extract-plugin
module.exports = {"ImageWrapper":"Home_ImageWrapper__7oat7","Image":"Home_Image__AElqy"};